export default __webpack_public_path__ + "static/news3-f205a4a0039318e7709d1fa732dfcf94.jpg";